import PropTypes from "prop-types";
import "./SummaryField.scss";

export function SummaryField({ data, label, id }) {
  return (
    <section key={id} data-id={id} data-testid={id} className="summary-field">
      <p className="summary-title">{label}</p>
      <p className="summary-content">{data}</p>
    </section>
  );
}

SummaryField.propTypes = {
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string.isRequired,
  id: PropTypes.string,
};

SummaryField.defaultProps = {
  data: "-",
  id: undefined,
};

export default SummaryField;
